exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-reset-form[data-v-0e34a402] {\n  text-align: left;\n}\n.password-reset-content-row[data-v-0e34a402] {\n  margin-top: 10vh;\n}\n.password-reset-card-container[data-v-0e34a402] {\n  background-color: white;\n  max-width: 600px;\n  text-align: center;\n  margin: auto;\n  padding-top: 48px;\n  padding-bottom: 38px;\n  padding-right: 30px;\n  padding-left: 30px;\n}\n.back-button-holder[data-v-0e34a402] {\n  margin-top: 35px;\n  text-align: left;\n}\n.password-reset-form-button[data-v-0e34a402] {\n  width: 100%;\n}\n", ""]);

// exports
